module.exports = __webpack_public_path__ + "media/images/application/doj-1d649f1f8afbdc6dd171175354da4f8c.jpg";